import { render } from "./priceitem-selector.vue?vue&type=template&id=0dca647c"
import script from "./priceitem-selector.vue?vue&type=script&lang=js"
export * from "./priceitem-selector.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__